import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { ExistingRoomEditDefault_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	roomID: string;
};

export const useRoomEditQuery = ({ hotelID, roomID }: Props) => {
	const { data } = useCustomSuspenseQuery(ExistingRoomEditDefault_EditPage_Query, {
		variables: { hotelID, roomId: roomID },
	});

	return data;
};
